import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import TpvService from '../../services/Order/TPVService';
import { Link, useNavigate } from 'react-router-dom'

export default function TpvOKPage() {
  const { locator } = useParams();
  let navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [alert, setAlert] = useState("");

  useEffect(() => {
    TpvService.tpvok(locator).then(
      response => {
        let order = response.content.order
        navigate("/compra-satisfactoria/" + order.id + "/" + order.locator, { replace: true })
      },
      error => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        setMessage(resMessage);
        setIsLoading(false);
        setAlert("danger");
      }
    );
  }, [])

  return (
    <React.Fragment>
      {isLoading && <span className="spinner-border"></span>}
      {message && (
        <div className="cardAccount__formGroup">
          {alert && alert === "danger" && (
            <div className="cardAccount__alert cardAccount__alert--danger" role="alert">
              {message}
            </div>)}
        </div>
      )}
    </React.Fragment>
  )
}